import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { LevelFormValues } from "src/models/Level.model";
import Level from "../Layouts/LevelForm";
import {
  useGetLevelByIdQuery,
  useUpdateLevelByIdMutation,
} from "src/services/LevelService";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";

type Props = {
  onClose: () => void;
  selectedLevelId: string;
};

const EditLevelWrapper = ({ onClose, selectedLevelId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } = useGetLevelByIdQuery(selectedLevelId);
  const [updateLevelById] = useUpdateLevelByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);

  const initialValues: LevelFormValues = {
    levelName: items?.levelName || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    levelName: string().required("Please enter level name"),
  });

  // Handle Submit
  const handleSubmit = (
    values: LevelFormValues,
    { setSubmitting, resetForm }: FormikHelpers<LevelFormValues>
  ) => {
    updateLevelById({ id: selectedLevelId, body: values }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <Level
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditLevelWrapper;
